import { useState, useEffect } from "react";

export function useIsMobileLandscape() {
  const [isMobileLandscape, setIsMobileLandscape] = useState(false);

  useEffect(() => {
    const check = () => {
      const isLandscape = window.innerWidth > window.innerHeight;
      const isMobile = /Mobi|Android/i.test(navigator.userAgent) || window.innerWidth <= 450;
      setIsMobileLandscape(isLandscape && isMobile);
    };

    check();
    window.addEventListener("resize", check);
    window.addEventListener("orientationchange", check);
    return () => {
      window.removeEventListener("resize", check);
      window.removeEventListener("orientationchange", check);
    };
  }, []);

  return isMobileLandscape;
}
